import React, { useState } from 'react';
import { GeneratedLinks } from './downloadTokens.types';
import { DownloadConfig } from './DownloadConfig';
import { DownloadTokenForm } from './DownloadTokenForm';
import { DownloadTokenTable } from './DownloadTokenTable';
import './DownloadTokens.module.css';

export function DownloadTokens() {
  const [generated, setGenerated] = useState<GeneratedLinks | null>(null);

  return (
    <div className="download-tokens-container">
      <DownloadConfig />
      <DownloadTokenForm generated={generated} onGenerated={setGenerated} />
      <DownloadTokenTable onReactivated={setGenerated} />
    </div>
  );
}
